import React from 'react';

const BurnInstructionsCard = ({ isOpen, onClose, burnAddress }) => {
  if (!isOpen) return null;

  const copyBurnAddress = async () => {
    try {
      await navigator.clipboard.writeText(burnAddress);
      alert('Burn address copied!');
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay */}
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      
      {/* Card */}
      <div className="relative bg-gradient-to-b from-gray-900 to-black border border-yellow-400/20 rounded-2xl p-8 max-w-md w-full mx-4 transform transition-all">
        {/* Close Button */}
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-yellow-400 transition-colors"
        >
          ✕
        </button>

        {/* Content */}
        <div className="text-center space-y-6">
          <span className="text-4xl animate-bounce inline-block">🔥</span>
          <h2 className="text-2xl font-bold bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
            Burn Your Tokens
          </h2>
          
          <div className="space-y-4">
            <p className="text-gray-300">Send your HFP tokens to this burn address:</p>
            
            {/* Burn Address */}
            <div className="bg-black/30 rounded-lg p-4 border border-red-500/20">
              <div className="flex items-center justify-between bg-black/50 rounded-lg p-3">
                <code className="text-red-400 text-xs sm:text-sm font-mono break-all">
                  {burnAddress}
                </code>
                <button
                  onClick={copyBurnAddress}
                  className="ml-2 p-2 hover:bg-white/5 rounded-lg transition-colors group"
                >
                  <span className="text-yellow-400 group-hover:scale-110 transition-transform inline-block">
                    📋
                  </span>
                </button>
              </div>
            </div>

            <div className="text-left space-y-2">
              <p className="text-yellow-400/80 font-semibold">Important:</p>
              <ul className="list-disc list-inside space-y-1 text-gray-400 text-sm">
                <li>Double check the address before sending</li>
                <li>Burned tokens cannot be recovered</li>
                <li>This action is irreversible</li>
              </ul>
            </div>

            <button
              onClick={copyBurnAddress}
              className="w-full bg-red-500/20 hover:bg-red-500/30 text-white font-bold py-3 px-6 rounded-full border border-red-500/50 transition-all duration-300 flex items-center justify-center gap-2"
            >
              <span>Copy Burn Address</span>
              <span className="text-lg">📋</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BurnInstructionsCard; 